<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <router-link :to="{ name: 'pelanggan-tambah'}"  class="btn btn-primary">Tambah Pelanggan</router-link>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 cariByTanggal" v-show="cariByTelepon">
            <div class="form-group">
            <input type="text" class="form-control" placeholder="Cari..." style="width:100%" v-model="telepon" />
          </div>
        </div>
        <div class="col-md-2 cariByTanggal" v-show="cariByTelepon">
            <div class="form-group">
            <button  class="btn btn-primary" @click="cariTeleponApi">Cari</button>
          </div>
        </div>
      </div>
      <div class="row" v-show="!isCari">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Daftar Pelanggan</h4>
                    <p class="card-category">Berikut daftar Pelanggan</p>
                  </div>
                  <div class="col-md-6">
                    <h2 class="card-title text-right">{{filtered}}</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Paket</th>
                      <th>Area</th>
                      <th>Biaya</th>
                      <th>Aksi</th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in pelanggan">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.user.unama }}</br>{{ u.user.wa }}</td>
                        <td>{{ u.user.pnama }}</br>Tagihan Tgl {{ u.user.tanggal_tagihan }}</td>
                        <td>{{ u.area }}</td>
                        <td>{{ ribu(u.user.ptarif) }}</td>
                        <td>
                          <router-link :to="{ name: 'pelanggan-detail', params: { id: u.user.uid, nama:u.user.unama, wa:u.user.wa, tgl:u.user.tanggal_tagihan, paket:u.user.pnama, bayar:u.user.ptarif, area:u.area  }}"  class="text-info" ><i class="material-icons">remove_red_eye</i> Detail</router-link>
                          <router-link v-show="false" :to="{ name: 'pelanggan-edit', params: { id: u.user.uid, nama:u.user.unama, wa:u.user.wa, tgl:u.user.tanggal_tagihan, paket:u.user.pnama, paketid:u.user.paket_id, bayar:u.user.ptarif, area:u.area, areaid:u.areaId, ppoe:u.user.ppoe  }}"  class="text-info" ><i class="material-icons">edit</i> Edit</router-link>

                          <button v-show="isAllow()" @click="showing = index, idHapus = u.user.uid" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i> Hapus</button>
                        </td>
                        <td>
                          <transition name="slide-fade" mode="out-in">
                            <button v-if="showing == index" v-show="showing == index" class="btn btn-sm btn-success slide-enter-active" @click="hapusUser(index)"><i class="material-icons">check_circle</i> Ya</button>
                          </transition>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>
      <div class="row" v-show="isCari">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Daftar Pelanggan Area "{{$route.params.nama}}"</h4>
                    <p class="card-category">Berikut daftar Pelanggan</p>
                  </div>
                  <div class="col-md-6">
                    <h2 class="card-title text-right">{{filtered}}</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Paket</th>
                      <th>Area</th>
                      <th>Biaya</th>
                      <th>Aksi</th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in pelangganCari">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.user.unama }}</br>{{ u.user.wa }}</td>
                        <td>{{ u.user.pnama }}</br>Tagihan Tgl {{ u.user.tanggal_tagihan }}</td>
                        <td>{{ u.area }}</td>
                        <td>{{ ribu(u.user.tarif) }}</td>
                        <td>
                          <router-link :to="{ name: 'pelanggan-detail', params: { id: u.user.uid, nama:u.user.unama, wa:u.user.wa, tgl:u.user.tanggal_tagihan, paket:u.user.pnama, bayar:u.user.ptarif, area:u.area  }}"  class="text-info" ><i class="material-icons">remove_red_eye</i> Detail</router-link>

                          <button v-show="isAllow()" @click="showing = index, idHapus = u.user.uid" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i> Hapus</button>
                        </td>
                        <td>
                          <transition name="slide-fade" mode="out-in">
                            <button v-if="showing == index" v-show="showing == index" class="btn btn-sm btn-success slide-enter-active" @click="hapusUser(index)"><i class="material-icons">check_circle</i> Ya</button>
                          </transition>
                        </td>
                      </tr>
                      <tr v-if="pelangganCari == null">
                        <td></td>
                        <td>Tidak ada Data</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>
      
      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalTopup">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Topup Pelanggan</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalTopup = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group" v-show="preCari">
											<label class="bmd-label-floating">Cari Pelanggan By Telepon</label>
											<input type="text" class="form-control" placeholder="Cari Kurir..." v-model="cariPelanggan">
							        <button type="button" class="btn btn-success btn-sm" @click="cariPelangganBtn">Cari Pelanggan</button>
											<label class="bmd-label-floating text-danger">{{textCariPelanggan}}</label>
										</div>
										<div class="form-group" v-show="!preCari">
											<label class="bmd-label-floating">Nama Pelanggan</label>
											<input type="text" class="form-control mb-2" placeholder="Jumlah Topup..." v-model="namaPelanggan" disabled>
											<input type="hidden" class="form-control" placeholder="Jumlah Topup..." v-model="idPelanggan">
											<label class="bmd-label-floating">Jumlah Topup</label>
											<input type="text" class="form-control mb-2" placeholder="Jumlah Topup..." v-model="topup">
											<label class="bmd-label-floating">Masukkan Password Anda</label>
											<input type="password" class="form-control" placeholder="Konfirmasi password..." v-model="password">
											
											<label class="bmd-label-floating text-danger">{{textSalah}}</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer" v-show="!preCari">
							<button type="button" class="btn btn-success" @click="simpanTopup">Simpan Topup</button>
						</div>
					</div>
				</div>
			</div>


    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

Vue.use(moment)

export default {
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment,
    'barcode': VueBarcode
  },
  data () {
    return {
      pelanggan: [],
      pelangganCari: [],
      cariByTelepon: false,
      
      showing: -1,
      telepon: '',
      dariTanggal: '',
      sampaiTanggal: '',
      statuse: '',
      filtered: '',

      // hapus
      idHapus: '',
      
      // cari kurir
      cariPelanggan: '',
      textCariPelanggan: '',
      textSalah: '',
      idPelanggan: '',
      namaPelanggan: '',

      // topup
      topup: '',
      password: '',


      // modal 
      modalTopup: false,
      preCari: true,

      isCari: false

    }
  },
  methods: {
    simpanTopup() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('idPelanggan', this.idPelanggan);
      data.append('jumlah', this.topup);
      data.append('password', this.password);
      
      var apiUrl = 'TopupPelangganConfirmByTeller';
      this.PostData(data,apiUrl).then(x => {
        this.loger(x);
        if (x.status) {
          this.modalTopup = false;
          this.getData();
        } else {
          this.textSalah = x.pesan;
        }
      })
    },
    cariPelangganBtn() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('cari', this.cariPelanggan);
      data.append('bulan', "0");
      data.append('type', "all");
      data.append('area', "null");
      data.append('tanggal', "null");
      
      var apiUrl = 'ListUserCari';
      this.PostData(data,apiUrl).then(x => {
        this.loger(x);
        return false;
        if (x.status) {
          this.preCari = !this.preCari;
          this.idPelanggan = x.data.id;
          this.namaPelanggan = x.data.nama;
        } else {
          //alert(x.pesan);
          this.textCariPelanggan = x.pesan;
        }
      })
    },
    customFormatter (date) {
        return moment(date).format('YYYY-MM-DD');
    },
    cariTelepon() {
      this.cariByTelepon = true;
    },
    cariTeleponApi() {
    },
    hapusUser(item) {
      
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', this.idHapus);
      
      var apiUrl = 'hapusUser';
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          this.getData();
          this.showing = -1;
        } else {
          //alert(x.pesan);
        }
      })

    },
    getData() {
      this.isCari = true;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('cari', "");
      data.append('bulan', "0");
      data.append('type', "all");
      data.append('area', this.$route.params.id);
      data.append('tanggal', "null");
      
      var apiUrl = 'ListUserCari';
      this.PostData(data,apiUrl).then(x => {
        this.loger(x);

        if (x.status == "true") {
          //this.preCari = !this.preCari;
          //this.idPelanggan = x.data.id;
          //this.namaPelanggan = x.data.nama;

          this.pelangganCari = x.data;
        } else {
          //alert(x.pesan);
          this.pelangganCari = x.data;
          this.textCariPelanggan = x.pesan;
        }
      })
    }
  },
  mounted () {
    this.getData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pelanggan/main-area.vue